import { createSlice } from '@reduxjs/toolkit';

const positions = createSlice({
    name: 'preHQPositions',
    initialState: {
        selectedPositions: [],
        reviewPolicies: [],
        positions: {
            data: [],
        },
    },
    reducers: {
        updatePositions(state, action) {
            state.positions.data = action.payload?.preHiringPositions;
        },
        setReviewPolicies(state, action) {
            state.reviewPolicies = action.payload;
        },
        updateSelectedPositions(state, action) {
            const { isChecked, rowId } = action.payload;

            if (isChecked) {
                state.selectedPositions.push(rowId);
                return;
            }
            state.selectedPositions = state.selectedPositions.filter((selectedRow) => selectedRow !== rowId);
        },
        updateAllSelectedPositions(state, action) {
            const { isChecked, positions } = action.payload;
            state.selectedPositions = [];
            if (isChecked) {
                positions.map((row) => state.selectedPositions.push(row.id));
                return;
            }
            state.selectedPositions = [];
        },
    },
});

export const { updatePositions, setReviewPolicies, updateSelectedPositions, updateAllSelectedPositions } =
    positions.actions;

export default positions.reducer;
